import nvSharedModelsModule from '../nv.shared.models.module';

angular
  .module(nvSharedModelsModule)
  .factory('AttendanceRecord', function(NvBaseModel, PublicConfig, $http, backgroundJob) {
    const PERMISSIONING_MODEL_NAME = 'ATTENDANCE_RECORD';
    const relationToUserPath = 'loggedBy.userId';

    let AttendanceRecord = NvBaseModel(
      // eslint-disable-line new-cap
      '/v1/attendanceRecords/:id',
      { id: '@_id' },
      {
        _whereQuery: {
          method: 'GET',
          isArray: true,
          transformResponse(data) {
            let json = angular.fromJson(data);
            // if the request is cancelled, json will be null
            if (json) return json.data;
          },
          params: {
            where: '@where',
          },
        },
      },
      null,
      PERMISSIONING_MODEL_NAME,
      relationToUserPath,
    );

    AttendanceRecord.queryBySupportId = function(supportId) {
      return AttendanceRecord._whereQuery({
        where: JSON.stringify({ supportId }),
      });
    };

    AttendanceRecord.queryBySupportIdAndEventDate = function(supportId, eventDate) {
      const query: any = { supportId };
      if (eventDate) query.eventDate = eventDate;
      return AttendanceRecord._whereQuery({
        where: JSON.stringify(query),
      });
    };

    AttendanceRecord.bulkCreate = function(data) {
      return $http({
        method: 'POST',
        url: PublicConfig.NV_API_ORIGIN + '/v1/attendanceRecords/bulk/create',
        data,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'text/html',
        },
      }).then(response => {
        if (response.headers('nv-background-jobs')) {
          return backgroundJob(response.headers('nv-background-jobs')).promise();
        }
        return response;
      });
    };

    AttendanceRecord.bulkUpdate = function(data) {
      return $http({
        method: 'PATCH',
        url: PublicConfig.NV_API_ORIGIN + '/v1/attendanceRecords/update/bulk',
        data,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'text/html',
        },
      }).then(response => {
        if (response.headers('nv-background-jobs')) {
          return backgroundJob(response.headers('nv-background-jobs')).promise();
        }
        return response;
      });
    };

    return AttendanceRecord;
  });
